var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSparkleAi = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20705 11.9024C6.42385 11.9024 6.5996 11.7442 6.63475 11.5098C7.13865 7.6074 7.68945 7.0508 11.5039 6.6289C11.7441 6.60545 11.9141 6.4297 11.9141 6.20115C11.9141 5.97265 11.7441 5.7969 11.5039 5.7676C7.68945 5.35156 7.13865 4.79492 6.63475 0.886719C6.5996 0.652344 6.42385 0.5 6.20705 0.5C5.99025 0.5 5.81445 0.652344 5.7793 0.886719C5.27539 4.79492 4.72461 5.35156 0.910156 5.7676C0.669922 5.7969 0.5 5.97265 0.5 6.20115C0.5 6.4297 0.669922 6.60545 0.910156 6.6289C4.72461 7.1328 5.24024 7.6133 5.7793 11.5098C5.81445 11.7442 5.99025 11.9024 6.20705 11.9024Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSparkleAi);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sparkle-ai.091d146b39c599767ff6e443a9fe210c.svg";